'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.string])), _react.PropTypes.node, _react.PropTypes.string]);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/childrenShape.js
// module id = 354
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15